<template>
  <b-modal :id="modalId" size="m" no-close-on-backdrop no-close-on-esc no-fade no-stacking centered>
    <template #modal-header>
      <b-row class="w-100" align-v="center" no-gutters>
        <b-col>
          <h2 class="modal-title">
            <i class="fas fa-exclamation-triangle colorOrange mr-1" />
            {{ $t('xLicenseRestriction') }}
          </h2>
        </b-col>
        <b-col cols="auto" class="float-right">
          <b-button
            class="btn-icon-button--gray"
            variant="icon-button"
            @click="$emit('onClose')"
            data-test-hook="x-button-fuel-monitors-not-allowed-button"
          >
            <i class="fas fa-times" />
          </b-button>
        </b-col>
      </b-row>
    </template>
    <b-row class="modal-body">
      {{ $t('xFuelMonitorsNotAllowedForRegion') }}
    </b-row>
    <template #modal-footer class="w-50">
      <slot />
    </template>
  </b-modal>
</template>
<script>
export default {
  props: ['modalId'],
  emits: ['onClose']
}
</script>
